module.exports = __webpack_public_path__ + "78d52114469531c0cf7d9e92124e5cca.jpg";